import { render, staticRenderFns } from "./ExaminationrecordsList.vue?vue&type=template&id=00a40658"
import script from "./ExaminationrecordsList.vue?vue&type=script&lang=js"
export * from "./ExaminationrecordsList.vue?vue&type=script&lang=js"
import style0 from "./ExaminationrecordsList.vue?vue&type=style&index=0&id=00a40658&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports